type PurchaseState = {
	platform: string | null;
	isLoading: boolean;
	isSuccess: boolean;
	isError: boolean;
	stripeData: any;
	stripeError: string | null;
	buyTokenAmountSubmit: number;
	paymentsLabel: string;
	stripePaymentLaunched: boolean;
};

type PurchaseAction =
	| { type: 'LOADING'; payload: boolean }
	| { type: 'ERROR'; payload: string }
	| { type: 'DATA'; payload: any }
	| { type: 'AMOUNT'; payload: number }
	| { type: 'PAYMENT_LAUNCHED'; payload: boolean }
	| { type: 'PLATFORM'; payload: string };

export function TokenPurchaseReducer(draft: PurchaseState, action: PurchaseAction) {
	switch (action.type) {
		case 'LOADING':
			draft.isLoading = action.payload;
			if (action.payload) {
				draft.isSuccess = false;
				draft.stripeError = null;
				draft.isError = false;
				draft.stripeData = null;
			}
			break;
		case 'ERROR':
			draft.isError = true;
			draft.stripeError = action.payload;
			draft.isSuccess = false;
			draft.stripeData = null;
			draft.isLoading = false;
			draft.buyTokenAmountSubmit = 0;
			break;
		case 'DATA':
			draft.isSuccess = true;
			draft.isError = false;
			draft.isLoading = false;
			draft.stripeError = null;
			draft.stripeData = action.payload;
			draft.buyTokenAmountSubmit = 0;
			break;
		case 'AMOUNT':
			draft.buyTokenAmountSubmit = action.payload;
			break;
		case 'PAYMENT_LAUNCHED':
			if (action.payload === true) {
				draft.isSuccess = false;
				draft.stripeError = null;
				draft.isError = false;
				draft.stripeData = null;
				draft.buyTokenAmountSubmit = 0;
			}
			draft.stripePaymentLaunched = action.payload;
			break;
		case 'PLATFORM':
			draft.platform = action.payload;
			break;
	}
	if (draft.platform !== 'web') {
		draft.paymentsLabel = 'Login using web to buy tokens';
		return draft;
	}
	if (draft.isLoading) {
		draft.paymentsLabel = 'Processing Payment';
		return draft;
	}
	if (
		!draft.stripePaymentLaunched &&
		draft.isSuccess &&
		draft.stripeData &&
		draft.stripeData?.status !== 'complete'
	) {
		draft.paymentsLabel = 'Complete purchase with Stripe';
		return draft;
	}
	draft.paymentsLabel = 'Buy tokens';
	return draft;
}
